import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment';

import { EditAndCreateContest } from '../../components/cmsEditAndCreate';
import * as appConstants from 'util/appConstants';
import PrimusHandler from 'api/primusHandler';

class Contest extends Component {
  state = {
    loading: true,
    status: appConstants.cmsStatus.loading,
    contestDetails: {
      _id: '',
      name: '',
      startDate: '',
      endDate: '',
      landingPageContent: '',
      contestLogo: '',
      landingPageLogo: '',
      contestBackground: '',
      candidateDescription: '',
      companyDescription: '',
      companyId: '',
      isTournament: '',
      autoRun: '',
      sponsorId: '',
      sponsorStartDate: '',
      sponsorEndDate: '',
      sponsorCompany: '',
      companiesList: [],
      oldSponsors: [],
    },
  };

  async componentDidMount() {
    if (this.props.match.params.id) {
      PrimusHandler.sendRequest({
        _handler: 'load-contest',
        _id: this.props.match.params.id,
        isReact: true,
      });
    } else {
      this.setState({ status: appConstants.cmsStatus.noChallenge });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.contestData) {
      this.setState({
        contestDetails: {
          _id: nextProps.contestData.data._id,
          name: nextProps.contestData.data.name,
          startDate: nextProps.contestData.data.startDate,
          endDate: moment(nextProps.contestData.data.endDate).utc().format(),
          landingPageContent: nextProps.contestData.data.landingPageContent,
          contestLogo: nextProps.contestData.data.contestLogo,
          landingPageLogo: nextProps.contestData.data.landingPageLogo,
          contestBackground: nextProps.contestData.data.contestBackground,
          candidateDescription: nextProps.contestData.data.candidateDescription,
          companyDescription: nextProps.contestData.data.companyDescription,
          companyId: nextProps.contestData.data.company,
          isTournament: nextProps.contestData.data.isTournament,
          isHackathon: nextProps.contestData.data.isHackathon,
          shortPath: nextProps.contestData.data.shortPath,
          autoRun: nextProps.contestData.data.autoRun ? true : false,
          sponsorId: nextProps.contestData.data.sponsorId ? nextProps.contestData.data.sponsorId : '',
          sponsorStartDate: nextProps.contestData.data.sponsorStartDate
            ? nextProps.contestData.data.sponsorStartDate
            : '',
          sponsorEndDate: nextProps.contestData.data.sponsorEndDate ? nextProps.contestData.data.sponsorEndDate : '',
          sponsorCompany: nextProps.contestData.data.sponsorCompany ? nextProps.contestData.data.sponsorCompany : '',
          companiesList: nextProps.contestData.data.companiesList,
          oldSponsors: nextProps.contestData.data.oldSponsors || [],
          tournamentRunTime: nextProps.contestData.data.tournamentRunTime
            ? nextProps.contestData.data.tournamentRunTime
            : false,
        },
        loading: false,
      });
    }
    if (nextProps.contestDetails && nextProps.contestDetails.updated) {
      toast.success(appConstants.cmsMessages.updateSuccess);
      this.setState({
        contestDetails: {
          _id: nextProps.contestDetails.data._id,
          name: nextProps.contestDetails.data.name,
          startDate: nextProps.contestDetails.data.startDate,
          endDate: nextProps.contestDetails.data.endDate,
          landingPageContent: nextProps.contestDetails.data.landingPageContent,
          contestLogo: nextProps.contestDetails.data.contestLogo,
          landingPageLogo: nextProps.contestDetails.data.landingPageLogo,
          contestBackground: nextProps.contestDetails.data.contestBackground,
          candidateDescription: nextProps.contestDetails.data.candidateDescription,
          companyDescription: nextProps.contestDetails.data.companyDescription,
          companyId: nextProps.contestDetails.data.company,
          isTournament: nextProps.contestDetails.data.isTournament,
          isHackathon: nextProps.contestDetails.data.isHackathon,
          shortPath: nextProps.contestDetails.data.shortPath,
          autoRun: nextProps.contestDetails.data.autoRun ? true : false,
          sponsorId: nextProps.contestDetails.data.sponsorId ? nextProps.contestDetails.data.sponsorId : '',
          sponsorStartDate: nextProps.contestDetails.data.sponsorStartDate
            ? nextProps.contestDetails.data.sponsorStartDate
            : '',
          sponsorEndDate: nextProps.contestDetails.data.sponsorEndDate
            ? nextProps.contestDetails.data.sponsorEndDate
            : '',
          sponsorCompany: nextProps.contestDetails.data.sponsorCompany
            ? nextProps.contestDetails.data.sponsorCompany
            : '',
          companiesList: nextProps.contestDetails.data.companiesList || [],
          oldSponsors: nextProps.contestDetails.data.oldSponsors || [],
          tournamentRunTime: nextProps.contestDetails.data.tournamentRunTime
            ? nextProps.contestDetails.data.tournamentRunTime
            : null,
        },
        loading: false,
      });
    }
  }

  componentWillUnmount() {
    this.props.resetUpdateData({
      _handler: 'update-contest',
      data: null,
    });
  }

  saveContest = (contestDetails) => {
    this.setState({ loading: true, status: appConstants.cmsStatus.updating });
    PrimusHandler.sendRequest({
      _handler: 'update-contest',
      contestName: contestDetails.contestName,
      landingPageContent: contestDetails.landingPageContentInHTML,
      images: {
        logo: contestDetails.logo,
        background: contestDetails.background,
        landingPageLogo: contestDetails.landingPageLogo,
      },
      contestStartDate: contestDetails.contestStartDate,
      contestEndDate: contestDetails.contestEndDate,
      candidateDescription: contestDetails.candidateDescriptionInHtml,
      companyDescription: contestDetails.companyDescriptionInHTML,
      contestId: this.state.contestDetails._id,
      companyId: this.state.contestDetails.companyId,
      autoRun: contestDetails.autoRun ? true : false,
      tournamentRunTime: contestDetails.tournamentRunTime ? contestDetails.tournamentRunTime : null,
      sponsorId: contestDetails.sponsorId ? contestDetails.sponsorId : '',
      sponsorStartDate: contestDetails.sponsorStartDate ? contestDetails.sponsorStartDate : '',
      sponsorEndDate: contestDetails.sponsorEndDate ? contestDetails.sponsorEndDate : '',
      sponsorCompany: contestDetails.sponsorCompany ? contestDetails.sponsorCompany : '',
      isHackathon: !!contestDetails.isHackathon,
      shortPath: contestDetails.shortPath,
      isReact: true,
      operation: 'save',
    });
  };

  render() {
    if (this.state.loading) {
      return <center className="noResults">{this.state.status}</center>;
    } else {
      return (
        <EditAndCreateContest
          history={this.props.history}
          saveContest={(contestDetails) => this.saveContest(contestDetails)}
          contestDetails={this.state.contestDetails}
          userRole={this.props.authData?.userRole}
        />
      );
    }
  }
}

const resetUpdateData = (data) => ({ type: 'STORE_PRIMUS_RESPONSE', payload: data });

const mapStateToProps = (state) => {
  return {
    contestDetails: state.data['update-contest'],
    contestData: state.data['load-contest'],
    authData: state['auth'],
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ resetUpdateData }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Contest);
